export default __webpack_public_path__ + "static/media/1-mobile.51ebc438.png";